<template>
  <owa-modal-frame
    :is-showing="isModalReady && isShowing"
    :has-sections="false"
    component-class="upsell"
    has-actions
    @close-modal="$emit('close-modal')"
  >
    <slot name="upsell-description">
      <h2 class="sr-only">Upgrade required.</h2>
      <p class="line-length-xl margin-bottom-xl text-center tablet:text-left">
        <span class="size-lg">
          <font-awesome-icon
            v-if="upsellTriggerIconName"
            :icon="$v7[upsellTriggerIconStyle][upsellTriggerIconName]"
            class="margin-right-5xs fa-lg"
          />
          <strong>{{ upsellTrigger }}</strong> requires a {{ upsellRequirement }}.
        </span>

        <span class="size-lg">
          <template v-if="skuCount === 1">Choose the plan below to continue.</template>
          <template v-else>Choose a plan below to continue.</template>
        </span>
      </p>
    </slot>

    <slot name="upsell-options">
      <upsell-options
        :icon="icon"
        :is-custom-icon="isCustomIcon"
        :upsell-trigger-slug="upsellTriggerSlug"
        :upsell-trigger="upsellTrigger"
        :require-pro-plus="requireProPlus"
        @onPlansReady="onPlansReady"
        @onSkuCount="onSkuCount"
      />
    </slot>

    <template slot="actions">
      <div class="row size-sm muted align-center tablet:align-start tablet:text-left">
        <div class="column-12 tablet:column-6">
          <p v-if="!isSignedIn">
            Already have a {{ upsellRequirement }}?
            <site-link
              :to="{ name: 'sessions.sign-in', query: { next: signInNext } }"
              class="no-underline"
              @click.native="$posthog.capture('sign_in_button_click', { context: 'upsell_modal', feature: upsellTriggerSlug })"
            >
              Sign in
            </site-link>
          </p>
        </div>
        <div :class="['column-12 tablet:column-6 tablet:text-right', { 'margin-top-md tablet:margin-top-0': !isSignedIn }]">
          <p>
            <site-link
              :to="{ name: 'plans' }"
              class="no-underline"
              @click.native="$posthog.capture('view_plans_button_click', { context: 'upsell_modal', feature: upsellTriggerSlug })"
              >View all plans and details</site-link
            >
          </p>
        </div>
      </div>
    </template>
  </owa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'
  import { EventTrackingMixin } from 'app/mixins'
  import { snakeCase } from 'lodash'
  import path from 'path'

  import UpsellOptions from './UpsellOptions'

  export default {
    name: 'ModalUpsell',

    components: {
      UpsellOptions
    },

    mixins: [ModalFrameMixin, EventTrackingMixin],

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      icon: {
        type: Object
      },
      isCustomIcon: {
        type: Boolean,
        default: false
      },
      isShowing: {
        type: Boolean,
        default: false
      },
      upsellRequirement: {
        type: String,
        required: true
      },
      upsellTrigger: {
        type: String,
        required: true
      },
      upsellTriggerIconName: {
        type: String,
        required: true
      },
      upsellTriggerIconStyle: {
        type: String,
        default: 'solid'
      },
      requireProPlus: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isModalReady: false,
        skuCount: 0
      }
    },

    computed: {
      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      signInNext() {
        return path.join(this.$router.history.base, this.$route.fullPath)
      },

      upsellTriggerSlug() {
        return snakeCase(this.upsellTrigger)
      }
    },

    methods: {
      onPlansReady(fetched) {
        this.isModalReady = fetched
      },

      onSkuCount(count) {
        this.skuCount = Number.isFinite(Number(count)) ? Number(count) : 0
      }
    }
  }
</script>
